import ConstList from './../ConstList'

/**
 * 申請・承認の失敗を、利用者が読める文言にする。
 *
 * この画面の catch は、失敗すると必ず GET /error/frontError/... を呼んでいた。
 * サーバにはPOSTしか無いのでその要求は404になり、内側の catch へ落ちて
 * 「システム通信エラーです。管理者に問い合わせてください。」が出る。
 * サーバが何を返しても同じ文言になり、原因も対処も伝わらない。
 *
 * 業務エラー（400・409）はサーバが利用者向けの文言を message に載せている。
 * それを出す。500と通信断だけ、従来どおりの案内にする。
 */
export function submissionErrorMessage (error) {
  const response = error && error.response ? error.response : null

  // 応答が無い＝通信できていない
  if (!response) return ConstList.SYSTEM_COMMUNICATION_ERROR

  const status = Number(response.status)
  const message = response.data && response.data.message
    ? String(response.data.message).trim()
    : ''

  // 400番台は利用者が対処できる。サーバの文言をそのまま見せる。
  if (status >= 400 && status < 500 && message) return message

  return ConstList.SYSTEM_ERROR
}
